import './App.css';

import LocalDiagramDownloader from './molecules/LocalDiagramDownloader'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          CORAS has moved to a new domain! Visit
        </p>
        <a
          className="App-link"
          href="https://coras.tools/"
          target="_blank"
          rel="noopener noreferrer"
        >
          coras.tools
        </a>
        <p>to create new diagrams.</p>
        <LocalDiagramDownloader />
        
      </header>
    </div>
  );
}

export default App;
